import { cva } from "cva";

export const headerLogoStyles = cva({
  base: "flex items-center justify-start gap-x-8 h-48 relative [&>*]:h-full [&>*]:w-auto whitespace-nowrap min-w-max will-change-transform",
});

export const headerLogoIconStyles = cva({
  base: "h-full w-auto aspect-square relative shrink-0",
});

export const headerLogoWordmarkStyles = cva({
  base: "text-headline-7 text-content-primary font-bold sr-only md:not-sr-only flex items-center justify-start",
});
